import React from 'react';
import { Spin } from 'antd';
import { CustomShipmentText } from '@/components';
import { CloseDrawerIcon, DownloadIcon } from '@/assets/icons/icons';
import DateTimeMenu from '../DateTimeMenu/DateTimeMenu';
import type { TimezoneMode } from '../../types';

interface ActivityPanelHeaderProps {
  tzMode: TimezoneMode;
  onTzModeChange: (mode: TimezoneMode) => void;
  subjectLabel?: string;
  isDownloading: boolean;
  onDownload: () => void;
  onClose: () => void;
}

const ActivityPanelHeader: React.FC<ActivityPanelHeaderProps> = ({
  tzMode,
  onTzModeChange,
  subjectLabel,
  isDownloading,
  onDownload,
  onClose,
}) => (
  <div className='activity-feed-header'>
    <CustomShipmentText
      text='Activity'
      fontSize={'16px'}
      fontWeight='600'
      lineHeight='20px'
    />
    <div className='activity-feed-header-actions'>
      <DateTimeMenu
        mode={tzMode}
        onChange={onTzModeChange}
        subjectLabel={subjectLabel}
      />
      <span
        className='activity-feed-header-icon-btn'
        aria-label='Export'
        title='Export'
        aria-busy={isDownloading}
        onClick={onDownload}
        style={
          isDownloading ? { pointerEvents: 'none', opacity: 0.6 } : undefined
        }
      >
        {isDownloading ? (
          <Spin size='small' />
        ) : (
          <DownloadIcon fill='var(--text-secondary)' />
        )}
      </span>
      <span
        className='activity-feed-header-icon-btn'
        aria-label='Close'
        title='Close'
        onClick={onClose}
      >
        <CloseDrawerIcon size={16} color='var(--text-primary)' />
      </span>
    </div>
  </div>
);

export default ActivityPanelHeader;
